import type {
  UiCreateUserDocument,
  UiUpdateUserDocument,
  ApiUserDocument,
  UiUserDocument,
} from '../../schemas/userDocument.schema';

export const mapUserDocumentFromApi = (
  doc: ApiUserDocument,
): UiUserDocument => ({
  id: doc.id,
  authorId: doc.authorId,
  authorName: doc.author?.name ?? null,
  category: {
    id: doc.categoryId,
    tag: doc.categoryTag
      ? { id: doc.categoryTag.id, translations: doc.categoryTag.translations }
      : undefined,
    translations: doc.category?.translations ?? [],
  },
  categoryId: doc.categoryId,
  createdAt: doc.createdAt,
  dateTime: doc.dateTime,
  displayUrl: doc.displayUrl,
  isVisibleToClient: doc.isVisibleToClient,
  isVisibleToTrainer: doc.isVisibleToTrainer,
  organizationId: doc.organizationId,
  sourceType: doc.sourceType,
  title: doc.title,
  userId: doc.userId,
});

export const createUserDocumentApiArgs = (ui: UiCreateUserDocument) => ({
  userId: ui.userId,
  ...(ui.organizationId ? { organizationId: ui.organizationId } : {}),
  categoryId: ui.categoryId,
  link: ui.link,
  sourceType: ui.sourceType,
  title: ui.title,
  ...(ui.categoryTagId ? { categoryTagId: ui.categoryTagId } : {}),
  dateTime: ui.dateTime.toISOString(),
  isVisibleToClient: ui.isVisibleToClient,
  isVisibleToTrainer: ui.isVisibleToTrainer,
});

export const updateUserDocumentApiArgs = (ui: UiUpdateUserDocument) => ({
  ...(ui.title !== undefined ? { title: ui.title } : {}),
  ...(ui.categoryId !== undefined ? { categoryId: ui.categoryId } : {}),
  ...(ui.categoryTagId !== undefined
    ? { categoryTagId: ui.categoryTagId }
    : {}),
});
